import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Logo from "@/components/Logo";
import { Gamepad2, Rocket, Loader2 } from "lucide-react";

const AVATARS = ["🦊", "🐼", "🐱", "🦁", "🐸", "🐵", "🦄", "🐧", "🐯", "🐰", "🐨", "🐙", "🐶", "🐷", "🐢", "🦉"];

export default function Jogar() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pin, setPin] = useState(params.get("pin") || "");
  const [nick, setNick] = useState("");
  const [avatar, setAvatar] = useState(() => AVATARS[Math.floor(Math.random() * AVATARS.length)]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const p = params.get("pin");
    if (p) setPin(p);
  }, [params]);

  const join = async (e) => {
    e.preventDefault();
    if (!pin || !nick) return;
    setLoading(true);
    try {
      const res = await api.post("/games/join", { pin: pin.trim(), nickname: nick.trim(), avatar });
      navigate(`/sala/${res.data.pin}`, { state: res.data });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Não foi possível entrar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-blue to-brand-purple flex flex-col items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-dots opacity-10" />
      <div className="absolute top-6 left-6"><Logo light /></div>
      <div className="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-brand-purple to-brand-blue flex items-center justify-center mx-auto text-white">
          <Gamepad2 className="w-8 h-8" />
        </div>
        <h1 className="mt-5 font-heading text-2xl font-black text-brand-ink">Entrar no jogo</h1>
        <p className="mt-2 text-sm text-brand-muted">Digite o token (PIN) e escolha seu nome. Funciona no celular e no computador.</p>
        <form onSubmit={join} className="mt-6 space-y-3">
          <Input value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Token / PIN" inputMode="numeric" className="rounded-xl h-14 text-center text-2xl font-heading font-bold tracking-widest" data-testid="join-pin" />
          <Input value={nick} onChange={(e) => setNick(e.target.value)} placeholder="Seu nome" maxLength={20} className="rounded-xl h-12 text-center" data-testid="join-nick" />
          <div className="text-left">
            <p className="text-xs font-semibold text-brand-muted mb-2">Escolha seu avatar</p>
            <div className="grid grid-cols-8 gap-1.5" data-testid="avatar-grid">
              {AVATARS.map((a) => (
                <button
                  key={a}
                  type="button"
                  onClick={() => setAvatar(a)}
                  data-testid={`avatar-${a}`}
                  className={`aspect-square rounded-lg text-xl flex items-center justify-center transition-all ${avatar === a ? "bg-brand-blue/15 ring-2 ring-brand-blue scale-110" : "bg-slate-100 hover:bg-slate-200"}`}
                >
                  {a}
                </button>
              ))}
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-brand-blue hover:bg-blue-700 gap-2 font-semibold" data-testid="join-btn">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Rocket className="w-5 h-5" /> Entrar {avatar}</>}
          </Button>
        </form>
        <button onClick={() => navigate("/")} className="mt-5 text-sm text-brand-muted hover:text-brand-ink">Voltar ao início</button>
      </div>
    </div>
  );
}
